var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "breadcrumb" }, [
    _c(
      "ul",
      _vm._l(_vm.levelList, function (item, index) {
        return _c("li", { key: item.path }, [
          item.redirect === "noredirect" || index == _vm.levelList.length - 1
            ? _c("span", [_vm._v(" " + _vm._s(item.meta.title))])
            : _c(
                "span",
                {
                  staticClass: "cursor",
                  on: {
                    click: function ($event) {
                      return _vm.handleLink(item)
                    },
                  },
                },
                [_vm._v(_vm._s(item.meta.title))]
              ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }